import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NAV_ITEMS = [
  { to: "/dashboard", labelKey: "nav.dashboard", icon: "🏠" },
  { to: "/dashboard/mba", labelKey: "nav.mba", icon: "🔗" },
  { to: "/import", labelKey: "nav.import", icon: "⬆️" },
  { to: "/plan", labelKey: "nav.plan", icon: "⚙️" },
];

export default function Sidebar() {
  const { t } = useTranslation();
  return (
    <aside className="sidebar">
      <div className="sidebar__brand">🛒 {t("appName")}</div>
      <nav className="sidebar__nav">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/dashboard"}
            className={({ isActive }) =>
              "sidebar__link" + (isActive ? " sidebar__link--active" : "")
            }
          >
            <span className="sidebar__icon">{item.icon}</span>
            <span>{t(item.labelKey)}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
